import type { FeatureLike } from "ol/Feature";
import type { MapBrowserEvent } from "ol";
import { CensusMapLocation } from "./CensusMapLocation";
import MapHover from "../../../../reactOL/interactions/MapHover";

interface GbCensusMapLocationHoverProps {
  onHoverLocation: (location: CensusMapLocation) => void;
}

const GbCensusMapLocationHover = ({
  onHoverLocation,
}: GbCensusMapLocationHoverProps) => {
  const onHover = (features: FeatureLike[], e: MapBrowserEvent<any>) => {
    if (features.length > 0) {
      const feature = features[0];
      const locationId = feature.get("id");
      if (locationId) {
        onHoverLocation({
          id: locationId,
          outputAreaId: feature.get("outputAreaId"),
        });
      }
    }
  };

  return <MapHover onHover={onHover} />;
};

export default GbCensusMapLocationHover;
